<template>
	<div>
		<vs-popup
			:active.sync="replyShowPopup"
			title="Vous-voulez repondre a ce message?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="replyMessage()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="closeReplyPopup()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<vs-popup :active.sync="$props.showPopup" title="Messages Collaborateur">
			<div ref="messageConsultantPopupRef">
				<vx-card class="mb-1">
					<div class="vx-row mb-2">
						<div class="vx-col mb-2">
							<h3>Filtres :</h3>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-input
								label="N° Contrat"
								class="inputx"
								placeholder="N° Contrat"
								v-model="contractNumberFilter"
								@input="notificationFilter()"
							/>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-input
								class="inputx"
								label="Client"
								placeholder="Client"
								v-model="societyFilter"
								@input="notificationFilter()"
							/>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-select
								v-model="userSelectedFilter"
								class="w-full select-large"
								label="Collaborateur"
								placeholder="Collaborateur"
								autocomplete
							>
								<vs-select-item
									key=""
									value=""
									text="Tous les collaborateur"
									class="w-full"
								/>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.firstname + ' ' + item.lastname"
									v-for="(item, index) in allCollaborators"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-select
								v-model="statusFilter"
								class="w-full select-large"
								label="Statut"
								placeholder="Statut de l'alerte"
								autocomplete
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.text"
									v-for="(item, index) in notificationStatus"
									class="w-full"
								/>
							</vs-select>
						</div>
					</div>
					<div class="vx-row w-full mt-2">
						<div class="vx-col">
							<strong>Nombre de résultats : {{ filteredNotes.length }}</strong>
						</div>
					</div>
				</vx-card>

				<div v-if="isLoading"><CircularLoader /></div>
				<vs-table
					v-else
					:data="filteredNotes"
					class="mt-3"
					style="overflow: hidden"
					noDataText="Aucun messages"
					:key="refreshListKey"
				>
					<template slot="thead">
						<vs-th>N°CONTRAT</vs-th>
						<vs-th>CLIENT</vs-th>
						<vs-th>A</vs-th>
						<!-- Madame ou Monsieur -->
						<vs-th>Par</vs-th>
						<vs-th>Message</vs-th>
						<vs-th>Date de création</vs-th>
						<vs-th></vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr
							:data="data[indextr]"
							:key="indextr"
							v-for="(tr, indextr) in data"
						>
							<vs-td :data="tr.contract_id">
								<span
									class="hvr-underline"
									@click="displayContractPopup(tr.contract_id)"
									><strong>{{ tr.contract_id }}</strong></span
								>
							</vs-td>
							<vs-td :data="tr.society_name">
								<span
									class="hvr-underline"
									@click="displaySocietyPopup(tr.society_id)"
									><strong>{{ tr.society_name }}</strong></span
								>
							</vs-td>
							<vs-td
								><vs-avatar
									style="border: 1px solid"
									:text="tr.destination_name"
									:src="getCollaboratorAvatar(tr.destination_user_id)"
							/></vs-td>
							<vs-td
								><vs-avatar
									style="border: 1px solid"
									:text="tr.created_name"
									:src="getCollaboratorAvatar(tr.created_user_id)"
							/></vs-td>

							<vs-td class="text-center">{{ tr.comment }}</vs-td>
							<vs-td class="text-center">{{
								getDateToFrenchFormat(tr.created_date)
							}}</vs-td>
							<vs-td style="width: 10%">
								<vs-button
									v-if="tr.notification_checked == 1"
									color="success"
									@click="toogleStatus(tr)"
									><vs-icon icon="check" size="medium"
								/></vs-button>
								<vs-button
									v-if="tr.notification_checked == 0"
									color="warning"
									@click="toogleStatus(tr)"
									><vs-icon icon="error" size="medium"
								/></vs-button>
							</vs-td>
							<!-- Madame ou Monsieur -->
							<!--<vs-td v-if="lead_account_manager == data[indextr]"><vs-button @click="deleteAccountManagerLead(data[indextr].id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
							<!-- <vs-td></vs-td> -->
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";

import store from "@/store/store";
import Notes from "@/entities/Notes";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import SocietyInfoPopupVue from "./SocietyInfoPopup.vue";
import ContractInfoPopupVue from "./ContractInfoPopup.vue";
import NotepadPopupVue from "./NotepadPopup.vue";

export default {
	name: "MessageConsultantPopup",
	components: { CircularLoader },
	props: {
		showPopup: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			// filter variables
			userSelectedFilter: null,
			statusFilter: null,
			collaboratorFilter: null,
			contractNumberFilter: null,
			societyFilter: null,
			allNotes: [],
			filteredNotes: [],
			refreshListKey: 0,
			statusFilter: 0,
			isLoading: true,
			notificationStatus: [
				{
					text: "A traiter",
					id: "0",
				},
				{
					text: "Traitée",
					id: "1",
				},
			],

			replyShowPopup: false,
			selectedRow: {},
			showNotepadPopup: false,
			// selectedUserId: null,
		};
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		allCollaborators() {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allSocieties: () => {
			return store.state.societies;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
	},
	async created() {
		try {
			this.isLoading = true;
			this.getAllCollaborators();
			this.getAllCollaboratorsAvatar();
			this.getAllSocieties();
			this.getAllContractsWithContractsUsers();

			this.userSelectedFilter = this.activeUser.id;
			await this.getNotes();
			this.isLoading = false;
		} catch (e) {
			this.isLoading = false;
			console.log(e);
		}
	},
	watch: {
		"this.$props.showPopup": function (val) {
			if (!val) {
				this.$router.push({
					path: this.$router.path,
					query: { ...this.$router.query, messageConsultant: undefined },
				});
			}
		},
		societyFilter: function (_) {
			this.filterNotes();
		},
		contractNumberFilter: function (_) {
			this.filterNotes();
		},
		statusFilter: function (val) {
			this.statusFilter = val;
			this.filterNotes();
		},
		userSelectedFilter: function (val) {
			this.getNotes();
		},
	},
	methods: {
		getAllContractsWithContractsUsers() {
			store.dispatch("getAllContractsWithContractsUsers");
		},
		/**
		 * Display the contract popup
		 * @param {Number} contract_id
		 */
		displayContractPopup(contract_id) {
			try {
				this.selectedContract = null;
				let foundContract = this.allContractsWithContractsUsers.findIndex(
					(row) => row.id == contract_id
				);
				if (foundContract < 0) {
					this.$vs.notify({
						title: "Erreur",
						text: "Contrat introuvable, contactez l'équipe technique.",
					});
					return false;
				}
				let account_manager_avatars = [];
				if (
					this.allContractsWithContractsUsers[foundContract].account_managers
				) {
					let contract_account_managers_names =
						this.allContractsWithContractsUsers[foundContract]
							.account_managers !== null
							? this.allContractsWithContractsUsers[
									foundContract
							  ].account_managers.split(", ")
							: [];
					let contract_account_managers =
						contract_account_managers_names.splice(
							0,
							contract_account_managers_names.length / 2
						);
					for (let i = 0; i < contract_account_managers.length; i++) {
						account_manager_avatars.push({
							name: contract_account_managers_names[i],
							users_id: contract_account_managers[i],
							is_lead:
								this.allContractsWithContractsUsers[foundContract].lead_am ==
								contract_account_managers[i]
									? 1
									: 0,
						});
					}
				}
				this.selectedContract =
					this.allContractsWithContractsUsers[foundContract];
				this.selectedContract.account_manager_avatars = account_manager_avatars;
				this.showContractPopup = true;

				//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
				let ComponentClass = Vue.extend(ContractInfoPopupVue);
				let contractPopup = new ComponentClass({
					propsData: {
						contract: this.selectedContract,
						popupActive: this.showContractPopup,
						router: this.$router,
						allowEdit: true,
						highZIndex: true,
					},
				});
				// @modify-contract="modifyContract($event)"
				contractPopup.$mount();
				contractPopup.$on("modify-contract", (contractId) => {
					this.popupActive = false;
					this.modifyContract(contractId);
				});
				contractPopup.$on("modify-missions", (contractId) => {
					this.popupActive = false;
					this.modifyMissions(contractId);
				});

				this.$refs.popupContainer.appendChild(contractPopup.$el);
			} catch (e) {
				console.log("err", e);
			}
		},
		/**
		 * Jump to updateContract page
		 */
		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},
		/**
		 * Jump to updateMission page
		 */
		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},
		/**
		 * Display the society popup
		 * @param {Number} societyId
		 */
		displaySocietyPopup(societyId) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it

			this.selectedSociety = JSON.parse(
				JSON.stringify(this.getSocietyById(societyId))
			);
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopupVue);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					allowEdit: true,
				},
			});
			societyPopup.$mount();
			societyPopup.$on("contract-info-popup", (contract) => {
				this.displayContractPopup(contract.id);
			});
			societyPopup.$on("refresh-client", () => {
				this.getAllSocieties();
			});
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},
		getAllSocieties() {
			store.dispatch("getAllSocieties");
		},
		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.allSocieties.find((society) => society.id == societyId);
		},

		filterNotes() {
			this.filteredNotes = this.allNotes;
			// filter by society
			if (this.societyFilter) {
				let tmpSocieties = this.allSocieties.filter((society) =>
					society.name.toLowerCase().includes(this.societyFilter.toLowerCase())
				);
				if (tmpSocieties.length > 0) {
					tmpSocieties = tmpSocieties.map((society) => {
						return society.id;
					});
					this.filteredNotes = this.filteredNotes.filter((n) =>
						tmpSocieties.includes(n.society_id)
					);
				}
			}
			// filter by contract number
			if (this.contractNumberFilter)
				this.filteredNotes = this.filteredNotes.filter((n) =>
					String(n.contract_id).includes(this.contractNumberFilter)
				);
			// filter by status
			if (this.statusFilter != null) {
				this.filteredNotes = this.filteredNotes.filter(
					(note) => note.notification_checked == this.statusFilter
				);
			}
			// console.log("SELECTED", this.userSelectedFilter, this.allNotes);
			// if (this.userSelectedFilter != null) {
			// 	this.filteredNotes = this.filteredNotes.filter(
			// 		(note) => note.destination_user_id == this.userSelectedFilter
			// 	);
			// }
		},

		getAllCollaborators() {
			store.dispatch("getAllCollaborators");
		},
		getAllCollaboratorsAvatar() {
			store.dispatch("getAllCollaboratorsAvatar");
		},
		/**
		 * Fetch all the societies
		 */
		getAllSocieties() {
			store.dispatch("getAllSocieties");
		},
		async getNotes() {
			try {
				this.allNotes = await Notes.getForNotes(this.userSelectedFilter);
				this.filterNotes();
			} catch (e) {
				console.log(e);
			}
		},
		async toogleStatus(row) {
			try {
				this.replyShowPopup = true;
				this.selectedRow = row;
				await Notes.checkNote(row.id, !row.notification_checked);
				this.getNotes();
				this.$vs.notify({
					title: "Succès",
					text: "Statut modifié avec succès",
					color: "success",
				});
			} catch (e) {
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la modification du statut",
					color: "danger",
				});
				console.log(e);
			}
		},
		async replyMessage() {
			this.closeReplyPopup();
			this.displayNotePadPopup(this.selectedRow);
		},
		closeReplyPopup() {
			this.replyShowPopup = false;
		},
		displayNotePadPopup(row) {
			// Initialisation des données pour le popup
			this.showNotepadPopup = true;
			// Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopupVue);
			let notepadPopup = new ComponentClass({
				propsData: {
					zIndex: 999999,
					contract_id: row.contract_id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					society_id: row.society_id,
					createdUserId: row.destination_user_id,
					destinationUserId:
						Number(row.created_user_id) || row.created_user_id, //the message should be sent back to who created
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},
	},
};
</script>

<style>
</style>